const data = {
  id: 1,
  title: 'Match the pictures with the correct words',
  subTitle: 'Nối hình với từ tương ứng',
  question: '',
  answers: [
    { id: 1, answer: 'ball', isCorrect: true, imageUrl: 'https://cloud.softech.vn/storage/SachSo/Images/Vocabulary/Starters/ball.png', audioUrl: '' },
    { id: 2, answer: 'hippo', isCorrect: true, imageUrl: 'https://cloud.softech.vn/storage/SachSo/Images/Vocabulary/Starters/hippo.png', audioUrl: '' },
  ],
};

export default data;
